// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jc5Y_7Q7BbVyLa9Bi2_Z {

}

.XImyC1PXAjX5gUXVJ14D {
    text-align: right;
}

.Omf2wWtPs6oHpugoNFP2 {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/format.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".special {\n\n}\n\n.controls {\n    text-align: right;\n}\n\n.close {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"special": `Jc5Y_7Q7BbVyLa9Bi2_Z`,
	"controls": `XImyC1PXAjX5gUXVJ14D`,
	"close": `Omf2wWtPs6oHpugoNFP2`
};
export default ___CSS_LOADER_EXPORT___;
